module.exports = __webpack_public_path__ + "static/img/003.2a70537d.png";